module.exports = __webpack_public_path__ + "img/home-nav-qsy-icon.5d2da0df.png";